/*
  HME — hover-to-open header dropdowns.

  Beds and Mobility (li.hme-hover-item, see snippets/header-dropdown-menu.liquid)
  use Dawn's stock <header-menu><details>/<summary> disclosure, which only opens
  on click. CPAP Machines/Masks/Supplies already open on hover via pure CSS
  (see hme-mega-machines.liquid and friends), and the owner wants Beds/Mobility
  to match that, without rebuilding them as full mega-menus.

  <details> content is hidden by the browser itself (not just CSS) until the
  `open` attribute is present, so a CSS-only :hover rule cannot reveal it.
  Setting `.open` from JS fires the native `toggle` event, which
  assets/details-disclosure.js already listens for (animation play/cancel,
  sticky-header preventHide bookkeeping) — so opening this way gets that
  behavior for free, same as a real click.

  Desktop pointer devices only. Touch devices keep the existing tap-to-open
  behavior untouched (a "hover" on tap would just make it feel stuck open).
*/
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var CLOSE_DELAY = 60;

  var items = document.querySelectorAll('.hme-hover-item');
  if (!items.length) return;

  var allDetails = [];

  items.forEach(function (item) {
    var details = item.querySelector('header-menu > details');
    if (!details) return;
    allDetails.push(details);

    var closeTimer = null;

    function open() {
      clearTimeout(closeTimer);
      // Moving straight from one hover dropdown to another (e.g. Beds ->
      // Mobility) shouldn't wait out the other one's own close delay.
      allDetails.forEach(function (d) {
        if (d !== details) d.open = false;
      });
      details.open = true;
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        if (!item.contains(document.activeElement)) details.open = false;
      }, CLOSE_DELAY);
    }

    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', scheduleClose);
  });
})();
